import {
  CURRENT_MODAL,
  QUERY_DETAILS,
  LOADING,
  LOAD_LOCATIONS,
  SHOW_SEARCH_RESULT,
  LIST_CATEGORIES,
  MEMBER_DETAILS,
  USER_DETAILS,
  SET_OTP,
  ACTIVITY_DETAILS,
  USER_DATA,
  USER_ID,
  USER_PHONE,
  BUTTON_LOADER,
  RESET_OTP,
  SET_PASSWORD
} from "../actions/constants";

export const initialState = {
  currentModal: "",
  activityDetails: {},
  queryDetails: {},
  memberDetails: {},
  userDetails: {},
  loading: false,
  locationsSuggestions: [],
  categories: [],
  showSearch: false,
  code: [],
  userData: {},
  buttonLoader: false
};

const reducer = function(state = initialState, action) {
  switch (action.type) {
    case CURRENT_MODAL:
      return { ...state, currentModal: action.payload };
    case ACTIVITY_DETAILS:
      return { ...state, activityDetails: action.payload };
    case QUERY_DETAILS:
      return { ...state, queryDetails: action.payload };
    case LOADING:
      return { ...state, loading: action.payload };
    case LOAD_LOCATIONS:
      return { ...state, locationsSuggestions: action.payload };
    case SHOW_SEARCH_RESULT:
      return { ...state, showSearch: action.payload };
    case LIST_CATEGORIES:
      return { ...state, categories: action.payload };
    case MEMBER_DETAILS:
      return { ...state, memberDetails: action.payload };
    case USER_DETAILS:
      return { ...state, userDetails: action.payload };
    case SET_OTP:
      return { ...state, code: [...state.code, action.payload] };
    case RESET_OTP:
      return { ...state, code: [] };
    case USER_DATA:
      return { ...state, userData: action.payload };
    case USER_ID:
      return { ...state, userData: { id: action.payload } };
    case USER_PHONE:
      return {
        ...state,
        userData: { ...state.userData, phone: action.payload.phone, countryCode: action.payload.countryCode }
      };
    case BUTTON_LOADER:
      return { ...state, buttonLoader: action.payload };
    case SET_PASSWORD:
      return { ...state, userData: { ...state.userData, password: action.payload } };
    default:
      return state;
  }
};

export default reducer;
